export const years = [
  {
    year: 2015,
    color: '#FF3333',
  },
  {
    year: 2016,
    color: '#FD9200',
  },
  {
    year: 2017,
    color: '#FDCB00',
  },
  {
    year: 2018,
    color: '#77FD00',
  },
  {
    year: 2019,
    color: '#00FDC0',
  },
  {
    year: 2020,
    color: '#069E47',
  },
  {
    year: 2021,
    color: '#069E99',
  },
  {
    year: 2022,
    color: '#0057DD',
  },
  {
    year: 2023,
    color: '#DD7200',
  },
  {
    year: 2024,
    color: '#C85BDE',
  },
  {
    year: 2025,
    color: '#9E0640',
  },
  {
    year: 2026,
    color: '#9F4545',
  },
  {
    year: 2027,
    color: '#3B3434',
  },
];
